"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.useConfigureIngest = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IngestProvider = _interopRequireDefault(require("@ccx-public/ccx-ingest/dist/components/IngestProvider"));

var _AppContext = _interopRequireDefault(require("../context/AppContext"));

var _constants = require("../constants");

var _lodash = _interopRequireDefault(require("lodash.merge"));

var _reducers = require("../reducers");

var _selectors = require("../selectors");

var _version = _interopRequireDefault(require("../version"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
// exporting for tests
var useConfigureIngest = function useConfigureIngest() {
  var appContext = (0, _react.useContext)(_AppContext.default);
  var analyticsData = appContext.analyticsData,
      assetData = appContext.assetData,
      globalComments = appContext.globalComments,
      globalCommentsToggle = appContext.globalCommentsToggle,
      imsData = appContext.imsData,
      locale = appContext.locale,
      compactLayout = appContext.compactLayout;
  var commentCounts = (0, _reducers.useSelector)(function (state) {
    return (0, _selectors.getCommentCounts)(state, appContext);
  });
  var validNodes = (assetData === null || assetData === void 0 ? void 0 : assetData.validNodes) || [];
  var hasMultipleNodes = Boolean(validNodes.length || Object.keys(commentCounts.allNodes || {}).length);
  var globalCommentsMode = globalComments && hasMultipleNodes && globalCommentsToggle.isActive;
  var userType = 'not-signed-in';
  var serviceLevel = 'not-signed-in';

  if (imsData !== null && imsData !== void 0 && imsData.token) {
    if (imsData.isGuestUser) {
      userType = 'guest';
      serviceLevel = 'guest';
    } else {
      userType = 'sign-in';
      serviceLevel = imsData !== null && imsData !== void 0 && imsData.isPaid ? 'paid' : 'trial';
    }
  }

  return (0, _lodash.default)({}, _constants.INGEST_INITIAL_STATE, {
    content: {
      id: assetData === null || assetData === void 0 ? void 0 : assetData.id,
      mimetype: assetData === null || assetData === void 0 ? void 0 : assetData.type
    },
    event: {
      language: locale,
      user_guid: imsData === null || imsData === void 0 ? void 0 : imsData.id,
      value: globalCommentsMode ? 'global' : 'non-global'
    },
    source: {
      version: _version.default
    },
    ui: {
      sequence: assetData === null || assetData === void 0 ? void 0 : assetData.nodeId,
      view_layout: compactLayout ? 'compact' : 'desktop'
    },
    user: {
      service_code: userType,
      service_level: serviceLevel
    }
  }, analyticsData);
};

exports.useConfigureIngest = useConfigureIngest;

var CommentsIngestProvider = function CommentsIngestProvider(_ref) {
  var children = _ref.children;
  var appContext = (0, _react.useContext)(_AppContext.default);
  var ingestProviderRef = (0, _react.useRef)();
  var ingestData = useConfigureIngest();
  return /*#__PURE__*/_react.default.createElement(_IngestProvider.default, {
    allowNoToken: true,
    apiKey: "CCXComments1",
    env: window.FORCE_STAGE_INGEST ? 'stage' : appContext.environment,
    data: ingestData,
    debounce: appContext.analyticsDebounce,
    product: "Comments/".concat(ingestData.source.version),
    project: _constants.INGEST_PROJECT_VALUE,
    ref: ingestProviderRef,
    disabled: !Object.keys(appContext.analyticsData || {}).length
  }, children);
};

CommentsIngestProvider.propTypes = {
  children: _propTypes.default.node
};
var _default = CommentsIngestProvider;
exports.default = _default;